import React from "react";

function IconMobile(props) {
  return (
    <svg width="12.5"  viewBox="0 0 12.5 20" {...props}>
      <path id="Path_578" data-name="Path 578" d="M10.625-17.5H1.875a1.808,1.808,0,0,0-1.328.547A1.808,1.808,0,0,0,0-15.625V.625A1.808,1.808,0,0,0,.547,1.953,1.808,1.808,0,0,0,1.875,2.5h8.75a1.808,1.808,0,0,0,1.328-.547A1.808,1.808,0,0,0,12.5.625v-16.25a1.808,1.808,0,0,0-.547-1.328A1.808,1.808,0,0,0,10.625-17.5ZM8.125.156a.452.452,0,0,1-.137.332.452.452,0,0,1-.332.137H4.844A.452.452,0,0,1,4.512.488.452.452,0,0,1,4.375.156V-.156a.452.452,0,0,1,.137-.332.452.452,0,0,1,.332-.137H7.656a.452.452,0,0,1,.332.137.452.452,0,0,1,.137.332Z" transform="translate(0 17.5)" />
    </svg>
  );
}

export default React.memo(IconMobile);
